module.exports = __webpack_public_path__ + "static/media/oneCamera.fba5f895.jpg";